<section class="callJournalPage">
  <header class="pageHeader">
    <div>
      <div class="eyebrow">Телефония</div>
      <h1>Журнал звонков</h1>
      <p *ngIf="periodLabel">{{ periodLabel }}</p>
    </div>

    <div class="toolbar">
      <mat-slide-toggle [(ngModel)]="missedOnly" (change)="load()">
        Требуют внимания
      </mat-slide-toggle>

      <mat-form-field class="periodSelect">
        <mat-label>Период</mat-label>
        <mat-select [(ngModel)]="selectedDays" (selectionChange)="load()">
          <mat-option *ngFor="let option of dayOptions" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <button mat-stroked-button color="primary" type="button" (click)="load()" [disabled]="loading">
        <mat-icon>refresh</mat-icon>
        Обновить
      </button>
    </div>
  </header>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <section class="summaryStrip" *ngIf="response">
    <div>
      <strong>{{ totalLabel }}</strong>
      <span>Всего: {{ response.total }}</span>
    </div>
    <div>
      <strong>{{ response.missedTotal }}</strong>
      <span>Без ответа</span>
    </div>
    <div>
      <strong>{{ response.unreturnedMissedTotal }}</strong>
      <span>Без перезвона</span>
    </div>
    <div>
      <strong>{{ response.voicemailTotal }}</strong>
      <span>Голосовая почта</span>
    </div>
  </section>

  <div class="errorState" *ngIf="error">
    <mat-icon>error_outline</mat-icon>
    <span>{{ error }}</span>
  </div>

  <section class="tableShell" *ngIf="!error">
    <table mat-table [dataSource]="calls" [trackBy]="trackByCall" *ngIf="calls.length; else emptyState">
      <ng-container matColumnDef="call">
        <th mat-header-cell *matHeaderCellDef>Звонок</th>
        <td mat-cell *matCellDef="let call">
          <div class="callCell">
            <strong>{{ call.callDateLabel }}</strong>
            <span [class]="getDirectionClass(call)">{{ call.directionLabel }}</span>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="client">
        <th mat-header-cell *matHeaderCellDef>Клиент</th>
        <td mat-cell *matCellDef="let call">
          <a
            *ngIf="getClientLink(call) as link; else plainClient"
            class="clientLink"
            [routerLink]="link"
          >
            <strong>{{ getClientLabel(call) }}</strong>
            <span>{{ getClientMeta(call) }}</span>
          </a>
          <ng-template #plainClient>
            <div class="clientLink clientLink--plain">
              <strong>{{ getClientLabel(call) }}</strong>
              <span>{{ getClientMeta(call) }}</span>
            </div>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="manager">
        <th mat-header-cell *matHeaderCellDef>Менеджер</th>
        <td mat-cell *matCellDef="let call">
          <span class="truncateText" [title]="getManagerLabel(call)">
            {{ getManagerLabel(call) }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Итог</th>
        <td mat-cell *matCellDef="let call">
          <div class="statusCell">
            <span [class]="getStatusClass(call)">{{ call.statusLabel }}</span>
            <small>{{ call.durationLabel }}</small>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="recording">
        <th mat-header-cell *matHeaderCellDef>Запись</th>
        <td mat-cell *matCellDef="let call">
          <audio *ngIf="call.recordingUrl; else noRecording" controls preload="none">
            <source [src]="call.recordingUrl" />
          </audio>
          <ng-template #noRecording>
            <span class="noRecording">Нет записи</span>
          </ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let call">
          <div class="actionButtons">
            <button
              mat-stroked-button
              color="primary"
              type="button"
              class="callbackButton"
              [disabled]="!canClickToCall(call) || callingCallId !== null"
              matTooltip="Перезвонить клиенту"
              (click)="clickToCall(call)"
            >
              <mat-icon *ngIf="callingCallId !== call.id">call</mat-icon>
              <mat-spinner *ngIf="callingCallId === call.id" diameter="18"></mat-spinner>
              <span>Перезвонить</span>
            </button>
            <button
              mat-icon-button
              type="button"
              class="hideButton"
              [disabled]="hidingCallId !== null"
              matTooltip="Скрыть звонок"
              (click)="hideCall(call)"
            >
              <mat-icon *ngIf="hidingCallId !== call.id">visibility_off</mat-icon>
              <mat-spinner *ngIf="hidingCallId === call.id" diameter="18"></mat-spinner>
            </button>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <ng-template #emptyState>
      <div class="emptyState" *ngIf="!loading">
        <mat-icon>phone_missed</mat-icon>
        <div>
          <strong>Звонков нет</strong>
          <span>
            {{
              missedOnly
                ? 'Нет пропущенных без перезвона и голосовых сообщений.'
                : 'За выбранный период звонков нет.'
            }}
          </span>
        </div>
      </div>
    </ng-template>
  </section>
</section>
